import type { LucideIcon, LucideProps } from 'lucide-react'
import { forwardRef } from 'react'

export const DocumentIcon: LucideIcon = forwardRef<SVGSVGElement, LucideProps>(({ size = 23, ...props }, ref) => {
  return (
    <svg
      ref={ref}
      width={size}
      height={(+size * 25) / 23}
      viewBox="0 0 23 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.3066 7.62665C17.7926 7.62665 18.1866 7.23266 18.1866 6.74665C18.1866 6.26065 17.7926 5.86665 17.3066 5.86665V7.62665ZM5.5733 5.86665C5.08729 5.86665 4.6933 6.26065 4.6933 6.74665C4.6933 7.23266 5.08729 7.62665 5.5733 7.62665V5.86665ZM17.3066 5.86665H5.5733V7.62665H17.3066V5.86665Z"
        fill="currentColor"
      />
      <path
        d="M17.3066 12.32C17.7926 12.32 18.1866 11.926 18.1866 11.44C18.1866 10.954 17.7926 10.56 17.3066 10.56V12.32ZM5.5733 10.56C5.08729 10.56 4.6933 10.954 4.6933 11.44C4.6933 11.926 5.08729 12.32 5.5733 12.32V10.56ZM17.3066 10.56H5.5733V12.32H17.3066V10.56Z"
        fill="currentColor"
      />
      <path
        d="M11.44 17.0133C11.926 17.0133 12.32 16.6193 12.32 16.1333C12.32 15.6473 11.926 15.2533 11.44 15.2533V17.0133ZM5.5733 15.2533C5.08729 15.2533 4.6933 15.6473 4.6933 16.1333C4.6933 16.6193 5.08729 17.0133 5.5733 17.0133V15.2533ZM11.44 15.2533H5.5733V17.0133H11.44V15.2533Z"
        fill="currentColor"
      />
      <path
        d="M3.22666 1.76H19.6533V0H3.22666V1.76ZM21.12 3.22666V21.0077H22.88V3.22666H21.12ZM19.1565 22.3878L17.324 21.728L16.728 23.384L18.5603 24.0437L19.1565 22.3878ZM14.9071 21.8215L12.0419 23.1108L12.7641 24.7158L15.6292 23.4265L14.9071 21.8215ZM10.8381 23.1108L7.97296 21.8215L7.25072 23.4265L10.1159 24.7158L10.8381 23.1108ZM5.55592 21.728L3.72345 22.3878L4.3196 24.0437L6.15206 23.384L5.55592 21.728ZM1.76 21.0077V3.22666H0V21.0077H1.76ZM3.72345 22.3878C2.76768 22.7318 1.76 22.0236 1.76 21.0077H0C0 23.2425 2.2169 24.8006 4.3196 24.0437L3.72345 22.3878ZM7.97296 21.8215C7.20988 21.4781 6.34324 21.4446 5.55592 21.728L6.15206 23.384C6.50994 23.2551 6.90387 23.2703 7.25072 23.4265L7.97296 21.8215ZM12.0419 23.1108C11.659 23.283 11.2209 23.283 10.8381 23.1108L10.1159 24.7158C10.958 25.0947 11.922 25.0947 12.7641 24.7158L12.0419 23.1108ZM17.324 21.728C16.5367 21.4446 15.6701 21.4781 14.9071 21.8215L15.6292 23.4265C15.9761 23.2703 16.37 23.2551 16.728 23.384L17.324 21.728ZM21.12 21.0077C21.12 22.0236 20.1123 22.7318 19.1565 22.3878L18.5603 24.0437C20.6631 24.8006 22.88 23.2425 22.88 21.0077H21.12ZM19.6533 1.76C20.4634 1.76 21.12 2.41664 21.12 3.22666H22.88C22.88 1.44463 21.4354 0 19.6533 0V1.76ZM3.22666 0C1.44463 0 0 1.44463 0 3.22666H1.76C1.76 2.41664 2.41664 1.76 3.22666 1.76V0Z"
        fill="currentColor"
      />
    </svg>
  )
})

DocumentIcon.displayName = 'DocumentIcon'
